import React, { useContext, useReducer, useEffect } from 'react';
import { Box, Tooltip, TextField } from '@mui/material'
import MegaAutoComplete from '../../../Utils/megautocomplete';
import ColorButton from '../../../Buttons/ColorButton';
import DefaultModal from '../../../Utils/DefaultModal';
import { lockedReducer } from '../../../Utils/reducers';
import { externalComponent } from '../../../AppRoutes';
import validateGrupo from './validateGrupo';
import { api } from '../../../../services/api';
import toast from 'react-hot-toast';

const url = '/grupo_filial/'
const submit = async (setLoader, data, getData, handleClose) => {

    setLoader(true)
    let res = null
    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 200) {
        toast.success(`Grupo filial ${!data.id ? 'adicionado' : 'editado'} com sucesso`)
        getData()
    }
    setLoader(false)
    handleClose()

}

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const loadRetrieve = async (id, setState, setLoader) => {
    setLoader(true)
    const res = await api.get(url + `${id}/`)
    if (res.status === 200) {
        setState({ ...res.data })
    }
    setLoader(false)
}



const EditGrupoFilial = ({ data, handleClose, reloadData }) => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        editRow: null,

        nome: '',
        default_name: '',
        branch: [],
        ...data,
        id: data.id ? data.id : 0

    })

    const { setLoader } = useContext(externalComponent)
    const validTable = validateGrupo(state)

    useEffect(() => {
        if (data.id)
            loadRetrieve(data.id, setState, setLoader)
        else
            setState({ loaded: true })
    }, [setLoader, data.id])


    return (
        <>
            <DefaultModal
                dialogProps={{ maxWidth: "sm" }}
                handleClose={handleClose}
                open={true}
                title={`${getTitle(state)} Grupo Filial`}
                content={

                    <Box className='item-content-modal noborder'>

                        <Box className='item-profile-row'>
                            <TextField
                                id="nomeGrupo"
                                type="text"
                                label="Nome"
                                size='small'
                                value={state.nome}
                                onChange={(e) => { setState({ nome: e.target.value }) }}
                                fullWidth={false}
                                sx={{ width: '100%' }}
                            />

                            <TextField
                                id="nomeDefault"
                                type="text"
                                label="Nome default"
                                size='small'
                                value={state.default_name}
                                onChange={(e) => { setState({ default_name: e.target.value }) }}
                                fullWidth={false}
                                sx={{ width: '100%' }}
                            />
                        </Box>


                        <Box className='item-profile-row'>
                            <MegaAutoComplete
                                multiple={true}
                                value={state.branch}
                                onChange={(data) => setState({ branch: data })}
                                noOptionsText={'Digite para procurar uma Filial'}
                                timeoutUrl='/frete/filiais'
                                timeoutParam='label'
                                label='Filial'
                            />
                        </Box>

                    </Box>

                }

                action={
                    <Tooltip title={validTable} placement="left">
                        <span>
                            <ColorButton disabled={validTable} onClick={() => submit(setLoader, state, reloadData, handleClose)}>Salvar</ColorButton>
                        </span>
                    </Tooltip>
                }
            />

        </>
    )
}

export default EditGrupoFilial;